import { render, staticRenderFns } from "./infoCom.vue?vue&type=template&id=efc21064&"
import script from "./infoCom.vue?vue&type=script&lang=js&"
export * from "./infoCom.vue?vue&type=script&lang=js&"
import style0 from "./infoCom.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports